module.exports = __webpack_public_path__ + "img/stadium.be5030ca.webp";